const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.35)',
    overflowY: 'auto',
    zIndex: '6',
  },
  content: {
    top: '30px',
    bottom: 'auto',
    background: '#fff',
    borderRadius: '10px',
    margin: 'auto',
    maxWidth: '600px',
    outline: 'none',
    inset: '30px 0 auto',
  },
};

export default modalStyles;
